import { Box, Grid, Link as MuiLink, makeStyles, Theme, Button } from "@material-ui/core";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { loader as vehicleLoader, setSelectedVehicleId } from "src/app-redux/vehicle/vehicleSlice";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { columns } from "./components/columns";
import { searchData } from "src/app-redux/common-actions";
import { getVehicleDetailsByIdAction } from "src/app-redux/vehicle/actions/vehicleActions";
import { Backdrop, Tooltip } from "@mui/material";
import { useAppSelector } from "src/app-redux/hooks";
import { filteryByArr } from "src/common/utils/app.dropdowns";
import { filterBy } from "src/common/utils/helpers";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { Check, Close } from "@material-ui/icons";
import Drawer from "src/modules/vehicle-management/pages/ListVehicles/components/Drawer";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  customButton: {
    "& .MuiButton-iconSizeSmall": {
      marginRight: "0",
    },
    "& .MuiBox-root": {
      marginRight: "8px",
    },
  },
}));

interface Props {}

export function ListVehicles({}: Props): React.ReactElement {
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const [loader, setLoader] = useState<any>(false);
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const loader2: any = useAppSelector(vehicleLoader);
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };
  const dispatch = useDispatch();

  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "vehicleNumber"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <>
                    <MuiLink
                      className="customMuiLink"
                      onClick={() => {
                        dispatch(getVehicleDetailsByIdAction(row.original.id));
                        dispatch(setSelectedVehicleId(row.original.id));
                        setisDrawerOpen(true);
                      }}
                    >
                      {renderedCellValue}
                    </MuiLink>
                  </>
                );
              },
            }
          : column.accessorKey === "vehicleInProgress"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.vehicleInProgress ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.vehicleInProgress ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "isAnomlyDetected"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.isAnomlyDetected ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.isAnomlyDetected ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);

  const { height } = UseWindowDimensions();
  let wHeight = 0;
  let gridMaxHeight = 0;
  let dppr = 10;
  wHeight = height - 132;
  gridMaxHeight = height - 200;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }
  const formik = useFormik({
    initialValues: {
      filterBy: "today",
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      invalidVehicleDataOnly: true,
    },
    onSubmit: (values) => {
      // alert(JSON.stringify(values, null, 2));
    },
  });

  const compareByDeletedDate = (a: any, b: any) => {
    const dateA = new Date(a.deletedAt);
    const dateB = new Date(b.deletedAt);

    if (dateA < dateB) {
      return 1;
    } else if (dateA > dateB) {
      return -1;
    } else {
      const timeA = new Date(a.deletedAt).getTime();
      const timeB = new Date(b.deletedAt).getTime();
      if (timeA < timeB) {
        return 1;
      } else if (timeA > timeB) {
        return -1;
      } else {
        return 0;
      }
    }
  };

  const handleSearch = async () => {
    const { filterBy, startDate, endDate, invalidVehicleDataOnly } = formik.values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      invalidVehicleDataOnly: invalidVehicleDataOnly || true,
    };
    setvehicleRecord([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-all-deleted-vehicles", JSON.stringify(body))
      );
      const apiRecord = results?.gateEnteries;
      if (apiRecord) {
        apiRecord.sort(compareByDeletedDate);
        const transformedData = apiRecord.map((data: any, index: any) => {
          return {
            ...data,
            id: data.gatePassId,
            yardSlotInfo:
              data.yardName && data.rowName && data.slotNumber
                ? `${data.yardName}, Row ${data.rowName}, Slot ${data.slotNumber}`
                : "",
          };
        });
        setvehicleRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };

  const [resetHandler, setResetHandler] = useState(false);
  const resetSearch = () => {
    formik.setValues(formik.initialValues);
    setIsCustomDate(false);
    setResetHandler(true);
  };

  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    handleSearch();
    setResetHandler(false);
  }, [resetHandler]);

  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
        formik.setFieldValue("startDate", res?.startDate);
        formik.setFieldValue("endDate", res?.endDate);
      }
    }
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader2}>
        <CommonLoader />
      </Backdrop>

      {!loader2 && (
        <Drawer
          isDrawerOpen={isDrawerOpen}
          handleCloseDrawer={() => {
            handleCloseDrawer();
          }}
        />
      )}

      <Grid spacing={2} container direction="row">
        <Grid item xs={12} md={3} lg={3}>
          <CommonAutoCompleteField
            cssClassName="customTextField"
            error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
            helperText={formik.touched.filterBy && formik.errors.filterBy}
            label="Filter by"
            placeholder="Filter by"
            name="filterBy"
            disableClearable={true}
            optionsType={filteryByArr}
            getOptionLabel={(option: any) => option.label || null}
            onChange={(row: any) => {
              row ? formik.setValues({ ...formik.values, filterBy: row.value || "" }) : "";
              if (row === null) {
                formik.setFieldValue("filterBy", null);
              }
              filterByAction(row);
            }}
            value={filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} className={!isCustomDate ? classes.hideDatesGrid : ""}>
          <CommonTextFieldDate
            cssClassName="customTextField"
            label={"Start Date"}
            name={"startDate"}
            datePickerRef={startDatePickerRef}
            value={formik.values.startDate}
            onChange={(e: any) => {
              formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
              formik.setFieldValue("endDate", "");
            }}
            maxDate={moment().format("YYYY-MM-DDTHH:mm")}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} className={!isCustomDate ? classes.hideDatesGrid : ""}>
          <CommonTextFieldDate
            cssClassName="customTextField"
            label={"End Date"}
            name={"endDate"}
            datePickerRef={endDatePickerRef}
            value={formik.values.endDate}
            onChange={(e: any) => {
              formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
            }}
            minDate={formik.values.startDate}
            maxDate={moment().format("YYYY-MM-DDTHH:mm")}
          />
        </Grid>

        <Grid item xs={12} md={isCustomDate ? 12 : 3} lg={isCustomDate ? 3 : 9}>
          <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
            <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
              Reset
            </CommonButton>
            <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
              Search
            </CommonButton>
          </Box>
        </Grid>
      </Grid>

      <CommonMaterialGrid
        rows={vehicleRecord}
        columns={displayColumns}
        loader={loader}
        defaultPerPageRecord={15}
        height={550}
      />
    </>
  );
}
